import { SchemaWidgetInstance } from '../SchemaWidgetClass'

export const productJson = (data: SchemaWidgetInstance, _page: unknown) => {
  const productJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: data.get('name'),
    description: data.get('description'),
    brand: {
      '@type': 'Brand',
      name: data.get('brandName'),
    },
    offers: {
      seller: {
        '@type': 'Organization',
        name: data.get('sellerName'),
        url: data.get('url'),
      },
      '@type': 'Offer',
      // set price on request: google validator has the price a mandatory field
      priceSpecification: {
        '@type': 'UnitPriceSpecification',
        price: 0,
        priceCurrency: 'EUR',
        priceType: 'https://schema.org/PriceUponRequest',
      },
      availability: 'https://schema.org/InStock',
    },
  }

  return productJsonLd
}
